import React, { forwardRef, SelectHTMLAttributes } from "react";

export interface SelectPaiementHebergementProps extends SelectHTMLAttributes<HTMLSelectElement> {
  className?: string;
  sizeClass?: string;
}

const SelectPaiementHebergement = forwardRef<HTMLSelectElement, SelectPaiementHebergementProps>(
  ({ className = "", sizeClass = "", children, ...args }, ref) => {
    return (
      <select
        ref={ref}
        className={`nc-SelectPaiementHebergement ${sizeClass} ${className} block w-full text-xs rounded-2xl border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900`}
        {...args}
      >
        {children}
      </select>
    );
  }
);

SelectPaiementHebergement.displayName = 'SelectPaiementHebergement';

export default SelectPaiementHebergement;
